<div class="repeat-section">
  <!-- @if (hasRepeatErrors()) {
    <div class="validation-errors">
      <div class="validation-error">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
    </div>
  } -->
  @if (rows.length > 0) {
    <table class="repeat-table">
      <thead>
        <tr>
          @for (templateField of fieldTemplate; track templateField.key || $index) {
            <th [class]="templateField.props.className ? templateField.props.className : ''">
              {{ (templateField.props?.['label'] || '') | translate }}
              @if(templateField.props?.required && !options.formState.disabled && !props['disabled'] && !props['readonly']) {
                <span class="required">*</span>
              }
            </th>
          }
          <th class="actions-column"></th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track $index) {
          <tr>
            @for (cellField of row.fields; track cellField.key || $index) {
              <td [attr.data-label]="(cellField.props?.['label'] + ':' || '') | translate">
                <formly-field [field]="cellField" style="font-weight: normal;"></formly-field>
                @if(hasErrors(cellField)) {
                  <div class="validation-errors">
                    @for(error of getErrorMessages(cellField); track $index) {
                      <div class="validation-error">{{error | translate}}</div>
                    }
                  </div>
                }
              </td>
            }
            <td class="actions-column" [attr.data-label]="'COMMON.ACTIONS' | translate">
              @if (!options.formState.disabled && !props['disabled'] && !props['readonly']) {
                <button 
                  class="remove-button" 
                  type="button" 
                  (click)="removeRow($index)" 
                  title="Remove item"
                  [attr.aria-label]="'Remove item ' + ($index + 1)">
                  <app-dynamic-icon name="close-circle"></app-dynamic-icon>
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
    <ng-template #fieldComponent></ng-template>
  }
  
  @if (!options.formState.disabled && !props['disabled'] && !props['readonly']) {
    <div class="repeat-section-footer">
      <div class="buttons">
        <button class="button" type="button" (click)="addRow()">
          {{ (props['addText'] || 'FORMS.ADD_ITEM') | translate }}
        </button>
      </div>
    </div>
  } @else if (!options.formState.showCompactViewWhenDisabled && rows.length === 0) {
    <div class="no-item-not-compact">-</div>
  }
</div>